import React, {Component, useEffect, useState} from 'react';
import './styles.scss';
import {compose} from 'redux';
import {connect} from 'react-redux';
import AppParagraph from '../../../../components/app-paragraph';
import {functionalitiesAliasMap, strings} from '../../../../util/strings';
import ModalTemplate from '../../../../components/modal';
import {Column, Row} from '../../../../components/layout';
import colors from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import * as Yup from 'yup';
import {
  AppForm,
  AppFormCheckboxField,
  AppFormSubmitButton,
} from '../../../../components/forms';
import {post} from '../../../../api/api';
import {uriPostConsentReceipts} from '../../../../api/endpoints';
import {getColor, labelsParagraphs} from '../../../../util/utility';
import {useHistory} from 'react-router-dom';
import AppButton from '../../../../components/app-button';
import Icon from '../../../../components/icon';
import {Icons} from '../../../../util/icons';
import CheckboxText from './components/CheckboxText';
import {ITenant} from '../../../../App';

interface AppointmentsPermissionsProps {
  show: boolean;
  setShowModal(value: any): void;
  labels: typeof strings.pt.appointments;
  labelsOneTrust: typeof strings.pt.oneTrust;
  user: any;
  globalStyles: any;
  selectedBu: any;
  setBypassPermissions(value: any): void;
  patientList: any;
  busFuncMapDefault: any;
  tenant: ITenant;
}

const validationSchema = Yup.object().shape({});

enum Bu {
  notClient = 'NOTCLIENT',
}

function AppointmentsPermissions({
  show,
  setShowModal,
  labels,
  labelsOneTrust,
  user,
  setBypassPermissions,
  globalStyles,
  selectedBu,
  patientList,
  busFuncMapDefault,
  tenant,
}: AppointmentsPermissionsProps) {
  const [oneTrustIsVisible, setOneTrustIsVisible] = useState(
    busFuncMapDefault?.[functionalitiesAliasMap.oneTrust]
  );

  labelsParagraphs(labels);

  const splitParagraphs =
    labels?.appointments_schedule_before_continue_description?.split('<p></p>');

  const paragraphWithLink = splitParagraphs.splice(-1);
  const paragraphsWithoutLink = splitParagraphs;

  //se os consents nao forem para mostrar o seu valor aqui fica a true, para desbloquear os botoes de submeter
  const [termsMain, setTermsMain] = useState(
    !(labelsOneTrust?.porpose_clinic_terms_main_show === 'true')
  );
  const [clinicConsent, setClinicConsent] = useState(
    !(labelsOneTrust?.porpose_clinic_consentimento_show === 'true')
  );
  const [clinicPolitica, setClinicPolitica] = useState(
    !(labelsOneTrust?.porpose_clinic_politica_show === 'true')
  );
  const [clinicEnquadramento, setClinicEnquadramento] = useState(
    !(labelsOneTrust?.porpose_clinic_enquadramento_show === 'true')
  );
  const [valid, setValid] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [showGeneralError, setShowGeneralError] = useState(false);
  const history = useHistory();

  const handleOnSubmit = async (values: any) => {
    const nif = user.nif;
    const token = labelsOneTrust?.tokenMyAdv;
    const body = JSON.stringify({
      identifier: nif,
      test: true,
      requestInformation: token,
      purposes: [
        {Id: labelsOneTrust?.porpose_clinic_consentimento},
        {Id: labelsOneTrust?.porpose_clinic_enquadramento},
        {Id: labelsOneTrust?.porpose_clinic_politica},
        {Id: labelsOneTrust?.porpose_clinic_terms_main},
      ],
    });
    try {
      oneTrustIsVisible && (await post(uriPostConsentReceipts(), body));
    } catch (e: any) {
    } finally {
      setShowModal(false);
      setBypassPermissions(true);
      setLoaded(true);
    }
  };

  useEffect(() => {
    if (loaded) {
      history.push({
        pathname: '/consultas-online/marcar-consulta',
        state: {
          patientList: patientList,
          editingAppointmentId: undefined,
        },
      });
    }
  }, [loaded]);

  const renderErrormodal = () => {
    return (
      <ModalTemplate
        className="appointment-cancel-container"
        contentClassName="appointment-cancel-content"
        show={showGeneralError}
        onHide={() => {
          setShowGeneralError(false);
        }}
        cross={true}
        hideFooter={true}
        size="sm">
        <div className="modal-error-container">
          <Row className="my-profile-submit-button-row">
            <Icon
              name={Icons.ALERT_PROBLEM}
              width={'40'}
              height={'40'}
              color={colors.alertRed}
              changeViewbox={false}
            />
          </Row>
          <Row className="errorPopup-title-row">
            <p
              style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
              className="p-errorPopup">
              {showGeneralError && labels?.appointments_error}
            </p>
          </Row>
          <Row className="my-profile-submit-button-row">
            <AppButton
              title="Ok"
              variant="primary"
              onClick={() => {
                setShowGeneralError(false);
              }}>
              Ok
            </AppButton>
          </Row>
        </div>
      </ModalTemplate>
    );
  };

  return (
    <div className="cancel-modal-container p-0">
      <ModalTemplate
        className="appointments-permissions-container"
        show={show}
        onHide={() => {
          setShowModal(false);
        }}
        cross={true}
        hideFooter={true}
        size="xl">
        <AppForm
          initialValues={{
            termsMain: false,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => handleOnSubmit(values)}
          onValidation={(valid: any) => setValid(valid)}>
          <Column className="myProfilePopup-column">
            <Row className="appointments-permissions-title-row">
              <p
                style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
                className="p-myProfilePopup">
                {labels?.appointments_schedule_before_continue}
              </p>
            </Row>
            <Row className="appointments-permissions-paragraph">
              <Column>
                <div className="description-half-container">
                  <AppParagraph
                    className="paragraph-text"
                    style={{...fonts.MM}}
                    label={paragraphsWithoutLink.join('<p></p>')}
                  />
                  <p
                    className="paragraph-text margin-top-paragraph"
                    style={{...fonts.MM}}>
                    {paragraphWithLink}
                    <a
                      target="_blank"
                      className="paragraph-text-link"
                      style={getColor('color')}
                      href={
                        labels?.appointments_schedule_before_continue_description_aqui_url
                      }>
                      {
                        labels?.appointments_schedule_before_continue_description_aqui
                      }
                    </a>
                  </p>
                </div>
                <div className="myProfile-text-row">
                  <AppParagraph
                    className="paragraph-text"
                    style={{...fonts.MM}}
                    label={
                      labels?.appointments_schedule_before_continue_description_2
                    }
                  />
                </div>
              </Column>
            </Row>
            {labelsOneTrust?.porpose_clinic_terms_main_show === 'true' && (
              <div className="consent-checkbox-row">
                <AppFormCheckboxField
                  name="terms_main"
                  className="consent-checkbox"
                  value={termsMain}
                  onChange={(value: any) => setTermsMain(value)}
                  label={
                    <CheckboxText
                      text={
                        labels?.appointments_schedule_before_continue_purpose2
                      }
                      textLink={
                        labels?.appointments_schedule_before_continue_purpose2_link
                      }
                      textUrl={
                        labels?.appointments_schedule_before_continue_purpose2_url
                      }
                    />
                  }
                />
              </div>
            )}
            {labelsOneTrust?.porpose_clinic_consentimento_show === 'true' && (
              <div className="consent-checkbox-row">
                <AppFormCheckboxField
                  name="clinic_consent"
                  className="consent-checkbox"
                  value={clinicConsent}
                  onChange={(value: any) => setClinicConsent(value)}
                  label={
                    <CheckboxText
                      text={
                        labels?.appointments_schedule_before_continue_purpose4
                      }
                      textLink={
                        labels?.appointments_schedule_before_continue_purpose4_link
                      }
                      textUrl={
                        labels?.appointments_schedule_before_continue_purpose4_url
                      }
                    />
                  }
                />
              </div>
            )}
            {labelsOneTrust?.porpose_clinic_politica_show === 'true' && (
              <div className="consent-checkbox-row">
                <AppFormCheckboxField
                  name="clinic_politica"
                  className="consent-checkbox"
                  value={clinicPolitica}
                  onChange={(value: any) => setClinicPolitica(value)}
                  label={
                    <CheckboxText
                      text={
                        labels?.appointments_schedule_before_continue_purpose3
                      }
                      textLink={
                        labels?.appointments_schedule_before_continue_purpose3_link
                      }
                      textUrl={
                        labels?.appointments_schedule_before_continue_purpose3_url
                      }
                    />
                  }
                />
              </div>
            )}
            {labelsOneTrust?.porpose_clinic_enquadramento_show === 'true' && (
              <div className="consent-checkbox-row">
                <AppFormCheckboxField
                  name="clinic_enquadramento"
                  className="consent-checkbox"
                  value={clinicEnquadramento}
                  onChange={(value: any) => setClinicEnquadramento(value)}
                  label={
                    <CheckboxText
                      text={
                        labels?.appointments_schedule_before_continue_purpose1
                      }
                      textLink={
                        labels?.appointments_schedule_before_continue_purpose1_link
                      }
                      textUrl={
                        labels?.appointments_schedule_before_continue_purpose1_url
                      }
                    />
                  }
                />
              </div>
            )}
            <Row className="appointment-permissions-button-row">
              <AppFormSubmitButton
                variant="inverted"
                className="appointments-permissions-confirm"
                type="submit"
                disabled={
                  !termsMain ||
                  !clinicPolitica ||
                  !clinicEnquadramento ||
                  !clinicConsent
                }
                title={labels?.appointments_schedule_before_continue_continue}
              />
            </Row>
          </Column>
        </AppForm>
      </ModalTemplate>
      {renderErrormodal()}
    </div>
  );
}

const mapStateToProps = ({
  strings,
  user,
  stringsDefault,
  globalStyles,
  selectedBu,
  busFuncMapDefault,
  tenant,
}: any) => ({
  labels: strings.value.pt.appointments,
  labelsOneTrust: stringsDefault.value.pt.oneTrust,
  user: user.value,
  globalStyles: globalStyles.value,
  selectedBu: selectedBu.value,
  busFuncMapDefault: busFuncMapDefault.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AppointmentsPermissions)
);
